import {
  GetSimilarByPatternSettingsArgs,
  UpdateSimilarByPatternSettingsPayload,
} from 'src/components-bl/SimilarByPattern/Actions/types';
import * as mapper from './mapper';
import * as builder from './builder';
import { SimilarByPatternSettingsTypes } from '../types';
import { ApiServiceBase } from '../api-service-base';

export class SimilarByPatternGeneralSettings extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl({ shopId }: GetSimilarByPatternSettingsArgs): string {
    return `${this.serviceBaseUri}/${shopId}/syte-products/similar-by-pattern/general-settings`;
  }

  async get({
    shopId,
  }: GetSimilarByPatternSettingsArgs): Promise<SimilarByPatternSettingsTypes.SimilarByPatternSettings> {
    const url = this.getUrl({ shopId });
    const response = await this.httpService.get({ url });
    return mapper.similarByPatternSettingsResponse(response);
  }

  async update({
    shopId,
    ...payload
  }: UpdateSimilarByPatternSettingsPayload): Promise<SimilarByPatternSettingsTypes.SimilarByPatternSettings> {
    const url = this.getUrl({ shopId });

    const data = builder.buildSimilarByPatternSettingsPayload(payload);
    const response = await this.httpService.patch({ url, data });
    return mapper.similarByPatternSettingsResponse(response);
  }
}
